var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-h5 text-md-h4 text-uppercase font-weight-medium title-widget",class:{
    'text-center': !_vm.left,
    'text-left': _vm.left,
    'grey--text text--darken-4': !_vm.light,
    'white--text': _vm.light,
  }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }